function turnOnTooltips() {
    if ($('body').hasClass('tooltips-on')) {
        $('[title]').tooltip();
    } else {
        $("a").removeAttr("title");
        $("button").removeAttr("title");
        $("input").removeAttr("title");
        $("div").removeAttr("title");
        $("textarea").removeAttr("title");
        $('[data-toggle="tooltip"]').tooltip('disable');
        $("a").removeAttr("tooltip");
        $("button").removeAttr("tooltip");
        $("input").removeAttr("tooltip");
        $("div").removeAttr("tooltip");
    }
}

function toggleShow() {
    if (!$('body').hasClass('sort-handles-on')){
        $('body').addClass('sort-handles-on');
        $("button.enable-sort-button").addClass('hidden');
        $("button.disable-sort-button").removeClass('hidden');
    } else {
        $('body').removeClass('sort-handles-on');
        $("button.enable-sort-button").removeClass('hidden');
        $("button.disable-sort-button").addClass('hidden');
    }
}

function strCompare(a, b) {
    // Use toUpperCase() to ignore character casing
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();

    let comparison = 0;
    if (nameA > nameB) {
        comparison = 1;
    } else if (nameA < nameB) {
        comparison = -1;
    }
    return comparison;
}


function toggleTooltips(userId){

}

function getBaseUrl() {
    return window.location.origin?window.location.origin+'/':window.location.protocol+'/'+window.location.host+'/';
}
function activateRemoveFileButton(){
    $('#remove-files').click(function (e) {
        e.preventDefault();
            var $el = $('#images');
            $el.wrap('<form>').closest('form').get(0).reset();
            $el.unwrap();
            updateUploadText();
    });
}

function singleRemoveFileButton(){
    $('#remove-files').click(function (e) {
        e.preventDefault();
        var $el = $('#upload');
        $el.wrap('<form>').closest('form').get(0).reset();
        $el.unwrap();
        singleUploadText();
    });
}

function singleUploadText() {
    var x = document.getElementById("upload");
    var txt = "";
    var fileTxt = "";
    var thisFile = x.files;
    console.log (thisFile);
    if ('files' in x) {
        if (x.files.length == 0) {

            txt = "Click to upload<br />- Or -<br />Drag and drop files here.";
        } else {
            txt = x.files.length + ' files selected.';
            fileTxt = '<strong>Files to be Uploaded: </strong><br />';
            fileTxt += '<ul>';
            for (var i = 0; i < x.files.length; i++) {
                var file = x.files[i];
                if ('name' in file) {
                    fileTxt += "<li><i class='fa fa-file-image-o'></i> "+ '\xa0' + file.name;
                }
                if ('size' in file) {
                    fileTxt += "(" + file.size + " bytes) </li>";
                }
            }
            fileTxt += '</ul>';
            fileTxt += '<button class="btn btn-warning btn-cancel" id="remove-files"><i class="fa fa-times"></i> Remove Files</button>';
            setTimeout(function(){ singleRemoveFileButton(); }, 300);
        }
    }
    $('#fakeupload > div > div').html(txt);
    $('#uploaded-files').html(fileTxt);

}

function updateUploadText(){
    var x = document.getElementById("images");
    var txt = "";
    var fileTxt = "";
    if ('files' in x) {
        if (x.files.length == 0) {

            txt = "Click to upload<br />- Or -<br />Drag and drop files here.";
        } else {
            txt = x.files.length + ' files selected.';
            fileTxt = '<strong>Files to be Uploaded: </strong><br />';
            fileTxt += '<ul>';
            for (var i = 0; i < x.files.length; i++) {
                var file = x.files[i];
                if ('name' in file) {
                    fileTxt += "<li><i class='fa fa-file-image-o'></i> "+ '\xa0' + file.name;
                }
                if ('size' in file) {
                    fileTxt += "(" + file.size + " bytes) </li>";
                }
            }
            fileTxt += '</ul>';
            fileTxt += '<button class="btn btn-warning btn-cancel" id="remove-files"><i class="fa fa-times"></i> Remove Files</button>';
            setTimeout(function(){ activateRemoveFileButton(); }, 600);
        }
    }
    $('#fakeupload > div > div').html(txt);
    $('#uploaded-files').html(fileTxt);
}

$(document).ready(function () {
    turnOnTooltips();
    // $('.chosen-container').tooltip();
    // $('[data-toggle="tooltip"]').tooltip();
});

